import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import AppTheme from '../shared-theme/AppTheme';
import AppAppBar from './components/AppAppBar';
import Hero from './components/Hero';
import CustomerLogos from './components/CustomerLogos';
import ProofSlab from './components/ProofSlab';
import HowWeWork from './components/HowWeWork';
import Features from './components/Features';
import PlatformGrid from './components/PlatformGrid';
import Highlights from './components/Highlights';
import BookingSection from './components/BookingSection';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function MarketingPage(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline />
      <AppAppBar />
      <Hero />
      <div>
        <CustomerLogos />
        <ProofSlab />
        <Features />
        <PlatformGrid />
        <Highlights />
        <Testimonials />
        <HowWeWork />
        <BookingSection />
        <FAQ />
        <Footer />
      </div>
    </AppTheme>
  );
}
